"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConfirmStageStyled_1 = __importDefault(require("./ConfirmStageStyled"));
const ErrorMessage_1 = __importDefault(require("../message/ErrorMessage"));
const Message_1 = __importDefault(require("../message/Message"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemActions_1 = __importDefault(require("../../actions/RedeemActions"));
const RedeemContainer_1 = __importDefault(require("./RedeemContainer"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const react_router_1 = require("react-router");
class ConfirmStage extends react_1.default.Component {
    constructor() {
        super(...arguments);
        /**
         * Attempt to add code to user's account
         */
        this.handleSend = () => {
            const submitData = {
                hostPageId: this.props.pageMapping,
                redeemCode: this.props.redeemStore.redeemCode,
                isLoggedIn: this.props.isLoggedIn
            };
            RedeemActions_1.default.redeemCode(submitData);
            RedeemActions_1.default.setNextStage(this.props.nextStage);
        };
        this.handleSubmit = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemConfirm',
                eventAction: 'send'
            });
            this.handleSend();
        };
        /**
         * Wipe all data from RedeemStore and go back to the first stage of the flow
         */
        this.handleReset = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemConfirm',
                eventAction: 'reset'
            });
            RedeemActions_1.default.resetFlow.defer();
        };
        this.handleRetry = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemConfirm',
                eventAction: 'retry'
            });
            this.handleSend();
        };
    }
    render() {
        const { redeemStore: { redeemError }, config } = this.props;
        const msgConfig = config.messages || {};
        const { errorMsgHandler } = config;
        let confirmStageView; //content to render
        const resetButton = (react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleReset, config: { buttonStyle: 'btn-default', inline: true, fixedWidth: true } },
            react_1.default.createElement(Message_1.default, { code: "epic.common.reset" })));
        const retryButton = (react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSubmit, config: { buttonStyle: 'btn-primary', inline: true, fixedWidth: true } },
            react_1.default.createElement(Message_1.default, { code: "epic.common.retry" })));
        const submitButton = (react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSubmit, config: { buttonStyle: 'btn-primary', inline: true, fixedWidth: true } },
            react_1.default.createElement(Message_1.default, { code: "epic.common.activate" })));
        if (this.props.redeemStore.loading) {
            confirmStageView = react_1.default.createElement("div", { className: "redeemLoading" });
        }
        else if (this.props.redeemStore.redeemError) {
            let errorData;
            const displayMetadata = [4002, 4001].includes(redeemError.numericErrorCode);
            if (displayMetadata) {
                errorData = (react_1.default.createElement("div", { className: "redeemInfo" },
                    react_1.default.createElement("div", { className: "itemTitle" }, this.props.redeemStore.title),
                    react_1.default.createElement("div", { className: "itemDescription" }, this.props.redeemStore.description)));
            }
            else {
                errorData = (react_1.default.createElement("div", { className: "errorData" },
                    react_1.default.createElement("div", { className: "errorPrimary" },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.confirm.code_intro" })),
                    react_1.default.createElement("div", { className: "errorSecondary" }, this.props.redeemStore.redeemCode)));
            }
            // error view
            confirmStageView = (react_1.default.createElement("div", null,
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: msgConfig['epic.code.redemption.confirm.title'] || 'epic.code.redemption.confirm.title' })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: "site-block-header" },
                        react_1.default.createElement("h1", { className: "site-block-title" },
                            react_1.default.createElement(Message_1.default, { code: "errors.com.epicgames.code.redemption.error" })),
                        react_1.default.createElement("div", { className: "clearfix" })),
                    errorData,
                    react_1.default.createElement("p", { className: "centered" }, errorMsgHandler ? (errorMsgHandler(redeemError, ErrorMessage_1.default)) : (react_1.default.createElement(ErrorMessage_1.default, { className: "errorMessage", msg: redeemError.message, code: redeemError.numericErrorCode, args: [redeemError.args] }))),
                    react_1.default.createElement("div", { className: "buttonContainer row" },
                        react_1.default.createElement("div", { className: "col-sm-6" }, resetButton),
                        react_1.default.createElement("div", { className: "col-sm-6" }, retryButton)))));
            /**
             * RENDER VIEW: Primary/default view
             */
        }
        else {
            confirmStageView = (react_1.default.createElement("div", null,
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: msgConfig['epic.code.redemption.confirm.title'] || 'epic.code.redemption.confirm.title' })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: "site-block-header" },
                        react_1.default.createElement("h1", { className: "site-block-title" },
                            react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.confirm.subtitle" })),
                        react_1.default.createElement("div", { className: "clearfix" })),
                    react_1.default.createElement("div", { className: "redeemInfo" },
                        react_1.default.createElement("div", { className: "itemTitle" }, this.props.redeemStore.title),
                        react_1.default.createElement("div", { className: "itemDescription" }, this.props.redeemStore.description)),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("p", { className: "centered" },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.confirm.msg" })),
                    react_1.default.createElement("div", { className: "buttonContainer row" },
                        react_1.default.createElement("div", { className: "col-sm-6" }, resetButton),
                        react_1.default.createElement("div", { className: "col-sm-6" }, submitButton)))));
        }
        return (react_1.default.createElement(ConfirmStageStyled_1.default, { className: "confirmStage" },
            react_1.default.createElement(RedeemContainer_1.default, { className: "redeemContainer" }, confirmStageView)));
    }
}
ConfirmStage.propTypes = {
    pageMapping: prop_types_1.default.string,
    redeemStore: prop_types_1.default.object,
    nextStage: prop_types_1.default.string,
    isLoggedIn: prop_types_1.default.bool,
    config: prop_types_1.default.object
};
exports.default = react_router_1.withRouter(ConfirmStage);
//# sourceMappingURL=ConfirmStage.js.map